/* 🤖 this file was generated by svg-to-ts */
export const iconArrowDown: {
    name: 'arrow_down';
    data: string;
} = {
    name: 'arrow_down',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22"><path fill="#000" fill-rule="evenodd" d="m6.896 21.478-.1-.008h-.004l-.002-.001-.045-.01-.033-.008-.015-.004a.6.6 0 0 1-.153-.073l-.027-.018-.046-.037-.034-.032-6.084-6.084a.65.65 0 0 1 .839-.987l.08.068 4.975 4.975V1.313a.65.65 0 0 1 1.292-.096l.007.096v17.946l4.974-4.975a.65.65 0 0 1 .988.839l-.069.08-6.076 6.078-.007.006-.019.018-.037.032.056-.05a1 1 0 0 1-.093.078l-.013.008-.03.018a.65.65 0 0 1-.324.087"/></svg>`
};
